'use client';

import HorizontalGallery from './horizontal-gallery';
import api from '../../../../domain/api';
import { useQuery } from '@tanstack/react-query';

export default function DashboardGalleryPage() {
  const {
    data: galleryItems,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ['gallery'],
    queryFn: async () => api.get('/gallery').then((res) => res.data),
  });

  if (isLoading) return <div>Loading gallery...</div>;
  if (isError) return <div>Error: {error.toString()}</div>;

  return (
    <div className='dashboard-section'>
      <HorizontalGallery items={galleryItems} title='Company Highlights' />
    </div>
  );
}
